import Nayose from './Nayose';
import PreleadStatus from './PreleadStatus';

export default {
  PreleadStatus,
  Nayose,
};
